import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaPhone,
  FaWhatsapp,
} from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-black w-full text-white py-6 px-4">
      <div className="mx-auto px-4 md:px-8 flex flex-col md:flex-row justify-between">
        {/* Logo and Address Section */}
        <div className="h-full">
          <div className="bg-white w-[200px] md:w-auto mb-5 md:mb-0 p-2 px-4 rounded-lg h-full mt-3">
            <a href="/">
              <img
                src="assets/spsu-logo.png"
                alt="SPSU Logo"
                className="h-16"
              />
            </a>
          </div>
          <div className="flex justify-start space-x-4 my-5">
            <a
              href="https://www.facebook.com/spsuofficial"
              target="_blank"
              rel="noreferrer noopener"
            >
              <FaFacebookF className="text-blue-500 cursor-pointer text-3xl" />
            </a>
            <a
              href="https://www.instagram.com/spsuofficial/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <FaInstagram className="text-pink-500 cursor-pointer text-3xl" />
            </a>
            <a
              href="https://www.linkedin.com/in/sir-padampat-singhania-university/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <FaLinkedinIn className="text-blue-700 cursor-pointer text-3xl" />
            </a>
            <a
              href="https://www.youtube.com/channel/UC8obPl4D4BCLGEmu9ynvw0Q/featured"
              target="_blank"
              rel="noreferrer noopener"
            >
              <FaYoutube className="text-red-500 cursor-pointer text-3xl" />
            </a>
          </div>
        </div>
        <div className="flex items-start space-x-4">
          <div>
            <h2 className="text-lg font-semibold pb-2">Address:</h2>
            <div className="flex pb-2">
              <p className="text-sm font-semibold pr-2">CITY OFFICE: </p>
              <p className="text-sm">
                Ground Floor, Lake City Mall, University Road,
                <br />
                Ashok Nagar, Udaipur, Rajasthan, India
              </p>
            </div>
            <div className="flex pb-2">
              <p className="text-sm font-semibold pr-2">CAMPUS: </p>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <p className="text-sm">
                Sir Padampat Singhania University Bhatewar,
                <br />
                Udaipur 313 601, Rajasthan, India
              </p>
            </div>
          </div>
        </div>

        {/* Contact Section */}
        <div className="text-left md:text-right my-5 md:my-0 ">
          <h2 className="text-lg font-semibold pb-2">Contact Us:</h2>
          <a href="tel:18998896555">
            <p className="text-xl font-bold pb-2">
              (Toll Free No.) 1800 8896 555
            </p>
          </a>
          <a href="mailto:admission@spsu.ac.in">
            <p className="text-xl font-bold pb-2">
              <strong>Email: </strong> admission@spsu.ac.in
            </p>
          </a>

          <a
            href="https://www.spsu.ac.in/"
            rel="noreferrer noopener"
            target="_blank"
            className="pb-3"
          >
            <span className="text-base font-bold pb-2 pr-2">
              Official Website:{' '}
            </span>
            <span className="text-base font-bold">www.spsu.ac.in</span>
          </a>
          <div className="flex justify-start md:justify-end space-x-4 mt-3">
            <a href="tel:18008896555" target="_blank" rel="noreferrer noopener">
              <FaPhone className="text-white cursor-pointer text-3xl" />
            </a>
            <a
              href="https://api.whatsapp.com/send?phone=919509627697&amp;text=I+would+like+to+know+more+&amp;utm_source=website&amp;utm_medium=whatsapp"
              target="_blank"
              rel="noreferrer noopener"
            >
              <FaWhatsapp className="text-green-500 cursor-pointer text-3xl" />
            </a>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="flex justify-center  mt-5">
        <div className="w-[150px] h-[2px] bg-white"></div>
      </div>
      <div className="text-center text-xs pt-4">
        Copyright © 2022-25 SPSU | All Rights Reserved
      </div>
    </footer>
  );
};

export default Footer;
